import { createFileRoute } from '@tanstack/react-router'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@lead-magnifier/ui'
import { Webhook, Construction } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/webhooks/')({
  component: WebhooksPage,
})

function WebhooksPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Webhooks</h1>
        <p className="text-muted-foreground mt-1">
          Erhalte Echtzeit-Benachrichtigungen zu Lead-Events
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Construction className="h-5 w-5" />
            Demnächst verfügbar
          </CardTitle>
          <CardDescription>
            Dieses Feature befindet sich noch in Entwicklung
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <Webhook className="h-16 w-16 text-muted-foreground/50 mb-4" />
            <h3 className="text-lg font-medium mb-2">Webhook-Integrationen</h3>
            <p className="text-sm text-muted-foreground max-w-md">
              Bald kannst du Webhooks einrichten, um automatisch
              benachrichtigt zu werden, wenn neue Leads erfasst oder
              bestätigt werden.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
